export const validation = {
  headingMaxChar: 60,
  subTitleMaxChar: 50,
  paragraphMaxChar: 400,
  footerParagraphMaxChar: 100,
  title: { required: true }
}
